const roundOffNum = num => {
	// if num doesn't have any decimal value by default, no decimal values are added to it
	// rounds off to 2 decimal places

	const roundedNum = Math.round(num * 100) / 100
	return roundedNum
}

export default roundOffNum
